module.exports = __webpack_public_path__ + "static/ManropeGX-f6fda7c58596387c25e11cfce56aa38f.ttf";